import { ADVERTISED_RATES_MAX_STUDY_IDS } from "@repo/api/use-cases/opportunity-listing/limits";

/**
 * The `getAdvertisedRates` input for a page of studies, built one way.
 *
 * Shared by the client hook and the server pages that prefetch it: the React
 * Query key is the input, so a page that dehydrates an answer under ids in a
 * different order, or with a duplicate, hydrates a cache entry nothing reads
 * and the client fetches the figure all over again.
 */
export function advertisedRatesInput(studyIds: (string | null | undefined)[]): {
  studyIds: string[];
} {
  return {
    studyIds: [...new Set(studyIds.filter((id): id is string => Boolean(id)))]
      .sort()
      .slice(0, ADVERTISED_RATES_MAX_STUDY_IDS),
  };
}

/** The key tRPC's React Query integration files that input's answer under. */
export function advertisedRatesQueryKey(input: { studyIds: string[] }) {
  return [
    ["opportunityListing", "getAdvertisedRates"],
    { input, type: "query" },
  ] as const;
}
